module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./QuickProductListView.js"));
	}, "QuickProductListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=QuickProductListView!./src/pages/Shop/Member/TradeManage/quickProductList/QuickProductListView.js
// module id = 1025
// module chunks = 438